module.exports = __webpack_public_path__ + "img/renyuanguanlianshenhe.fb3d58c9.png";